var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.001 28a.998.998 0 0 1-.8-.4l-.815-1.086a8.998 8.998 0 0 1-1.6-7.286l1.473-6.876a6.996 6.996 0 0 0-1.245-5.667L23.2 5.6a1 1 0 1 1 1.6-1.2l.815 1.086a8.998 8.998 0 0 1 1.6 7.285l-1.474 6.876a6.996 6.996 0 0 0 1.245 5.667L27.8 26.4a1 1 0 0 1-.799 1.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.001 28a.998.998 0 0 1-.8-.4l-.815-1.086a8.998 8.998 0 0 1-1.6-7.286l1.473-6.876a6.996 6.996 0 0 0-1.245-5.667L18.2 5.6a1 1 0 1 1 1.6-1.2l.815 1.086a8.998 8.998 0 0 1 1.6 7.285l-1.474 6.876a6.996 6.996 0 0 0 1.245 5.667L22.8 26.4a1 1 0 0 1-.799 1.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.001 28a.998.998 0 0 1-.8-.4l-.815-1.086a8.998 8.998 0 0 1-1.6-7.286l1.473-6.876a6.996 6.996 0 0 0-1.245-5.667L13.2 5.6a1 1 0 1 1 1.6-1.2l.814 1.086a8.998 8.998 0 0 1 1.601 7.285l-1.474 6.876a6.996 6.996 0 0 0 1.245 5.667L17.8 26.4a1 1 0 0 1-.799 1.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 28a.998.998 0 0 1-.8-.4l-.815-1.086a8.998 8.998 0 0 1-1.6-7.286l1.473-6.876a6.996 6.996 0 0 0-1.245-5.667L8.2 5.6a1 1 0 1 1 1.6-1.2l.815 1.086a8.998 8.998 0 0 1 1.6 7.285l-1.474 6.876a6.996 6.996 0 0 0 1.245 5.667L12.8 26.4a1 1 0 0 1-.799 1.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.001 28a.998.998 0 0 1-.801-.4l-.815-1.086a8.998 8.998 0 0 1-1.6-7.286l1.474-6.876a6.996 6.996 0 0 0-1.245-5.667L3.2 5.6a1 1 0 1 1 1.6-1.2l.815 1.086a8.998 8.998 0 0 1 1.6 7.285l-1.474 6.876a6.996 6.996 0 0 0 1.245 5.667L7.8 26.4a1 1 0 0 1-.799 1.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.dbfd49526a112c74b7e78f773b78a649.svg";
export { ForwardRef as ReactComponent };